import flatten from 'flat';
import { useFormikContext } from 'formik';
import { RefObject, useEffect, useRef } from 'react';

const useScrollToFirstInvalidField = (name: string, inputRef: RefObject<HTMLInputElement>) => {
  const { errors, submitCount } = useFormikContext<any>();
  const prevSubmitCount = useRef(submitCount);

  useEffect(() => {
    const errorFieldNames = Object.keys(flatten(errors));
    if (!errorFieldNames.length || submitCount === prevSubmitCount.current) {
      return;
    }

    prevSubmitCount.current = submitCount;
    const firstInvalidFieldName = errorFieldNames[0];
    if (name + '.key' === firstInvalidFieldName) {
      inputRef.current?.scrollIntoView({ block: 'center', behavior: 'smooth' });
      inputRef.current?.focus({ preventScroll: true });
    }
  }, [submitCount, errors]);
};

export default useScrollToFirstInvalidField;
